// extracted by mini-css-extract-plugin
export default {"iconContainer":"copylink_iconContainer__OnIDh","toastContainer":"copylink_toastContainer__R-8SB","slide-in-bottom":"copylink_slide-in-bottom__6e4sB"};